import { render, staticRenderFns } from "./eventForm.vue?vue&type=template&id=318c2da7&scoped=true&"
import script from "./eventForm.vue?vue&type=script&lang=js&"
export * from "./eventForm.vue?vue&type=script&lang=js&"
import style0 from "./eventForm.vue?vue&type=style&index=0&id=318c2da7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c2da7",
  null
  
)

export default component.exports